export default {
  auth: {
    login: `${import.meta.env.VITE_API_URL}/auth/login`,
    logout: `${import.meta.env.VITE_API_URL}/auth/logout`,
    session: `${import.meta.env.VITE_API_URL}/auth/session`,
    mfa: {
      resend: `${import.meta.env.VITE_API_URL}/auth/mfa`,
      verify: `${import.meta.env.VITE_API_URL}/auth/mfa/verify`,
    },
  },
  public: {
    answer: `${import.meta.env.VITE_API_URL}/public/answer/`,
    eventLocator: `${import.meta.env.VITE_API_URL}/public/event-locator/`,
    events: (form_key: string): string =>
      `${import.meta.env.VITE_API_URL}/public/events?form_key=${encodeURIComponent(form_key)}`,
    form: (instance_key: string): string =>
      `${import.meta.env.VITE_API_URL}/public/form/?instance_key=${encodeURIComponent(instance_key)}`,
    entries: (instance_key: string, email: string): string =>
      `${import.meta.env.VITE_API_URL}/public/entries?instance_key=${encodeURIComponent(instance_key)}&email=${encodeURIComponent(email)}`,
    survey: (instance_key: string): string =>
      `${import.meta.env.VITE_API_URL}/public/form?instance_key=${encodeURIComponent(instance_key)}`,
    waiver: (instance_key: string): string =>
      `${import.meta.env.VITE_API_URL}/public/waiver/?instance_key=${instance_key}`,
  },
};
